module.exports = __webpack_public_path__ + "img/Excavator.870818f8.png";